import React, { FunctionComponent } from 'react';

import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { Controller } from 'react-hook-form';
import FormLabel from '@mui/material/FormLabel';
import TextField from '@mui/material/TextField';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import dayjs, { Dayjs } from 'dayjs';

import { DatePicker, DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CascadeSelection from '../Calendar/AddressSelect';
import { Checkbox, Stack, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
const validateHelper = {
    show_name: {
        required: 'Show Name is Required',

    },
    paddock_name: {
        required: 'Paddock Name is Required',

    },
    yob: {
        required: 'Birth date is Required',
    },
    weight: {
        required: 'Weight is Required',
    },
    height: {
        required: 'Height is Required',
    },
    gender: {
        required: 'Gender is Required',
    },
    register_number: {
        required: 'Registration Name is Required',
    },
    microchip_no: {
        required: 'Microchip Number is Required',
    },
    breed: {
        required: 'Breed is Required',
    },
    colour: {
        required: 'Colour is Required',
    },
    discipline: {
        required: 'Discipline is Required',
    },
    sire: {
        required: 'Sire is Required'
    },
    dam: {
        required: 'Dam is Required'
    },
    dam_sire: {
        required: 'Dam Sire is Required'
    },
    date_purchased: {
        required: 'Purchased Date is Required'
    },
    gear_used: {
        required: 'Gear used is Required'
    },
    notes: {
        required: 'Notes is Required'
    }
}
type Props = {
    control: any,
    name: string,
    label: string,
    multiline?: boolean,
    customLabel?: JSX.Element,
    disabled?: boolean,
    placeholder?: string,
    required?: boolean,
    desc?: string | React.ReactNode,
}

export const FormTextField: FunctionComponent<Props> = (props) => {
    return <Controller
        rules={{ required: props.required ? props.required : false }}
        control={props.control}
        name={props.name}
        render={({ field, fieldState: { error } }) => (
            <>
                {props.customLabel ? props.customLabel : <StyleFormLabel>{props.label} </StyleFormLabel>}
                {props.multiline == true ? <ResponsiveTextField
                    disabled={!props.disabled}
                    multiline
                    maxRows={6}
                    InputProps={{ sx: { height: 90, borderRadius: 1 } }}
                    placeholder={props.placeholder}
                    {...field}
                    error={error !== undefined} helperText={props.desc ? props.desc : error ? validateHelper[props.name][error.type] : ''}
                /> : <ResponsiveTextField placeholder={props.placeholder} disabled={!props.disabled} InputProps={{ sx: { height: 30, borderRadius: 1 } }} {...field}
                    error={error !== undefined} helperText={props.desc ? props.desc : error ? validateHelper[props.name][error.type] : ''}
                />}
            </>
        )}
    />
}


export const FormCheckBoxField: FunctionComponent<Props> = (props) => {
    return (
        <Controller
            rules={{ required: props.required ? props.required : false }}
            control={props.control}
            name={props.name}
            render={({ field, fieldState: { error } }) => {
                // 将传入的字符串值转换为布尔值
                const checked = field.value === 'true';

                return (
                    <FormControlLabel
                        sx={{ margin: 0 }}
                        control={
                            <Checkbox
                                {...field}
                                checked={checked}
                                onChange={(e) => field.onChange(e.target.checked.toString())} // 转换回字符串
                            />
                        }
                        label={props.label}
                    />
                );
            }}
        />
    );
};

interface DateFieldProps extends Props { label: string, setValue: (name: string, value: string | number) => void }
export const FormDateField: FunctionComponent<DateFieldProps> = (props) => {
    const [date, setDate] = React.useState<Dayjs | null>(null);
    return <Controller
        control={props.control}
        name={props.name}
        render={({ field, fieldState: { error } }) => (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label={props.label}
                    value={date}
                    onChange={(newValue) => {
                        newValue && props.setValue(props.name, newValue?.unix())
                        setDate(newValue);
                    }}
                    inputFormat='DD/MM/YYYY'
                    PopperProps={{
                        sx: {
                            ".MuiButtonBase-root": {
                                padding: '8px !important',
                                background: 'transparent !important'
                            },

                            "div.MuiYearPicker-root > .PrivatePickersYear-modeDesktop > .PrivatePickersYear-yearButton": {
                                padding: '0 !important',
                                background: 'transparent !important'
                            },
                            ".PrivatePickersYear-root.PrivatePickersYear-modeMobile > .PrivatePickersYear-yearButton": {
                                padding: '0 !important',
                                background: 'transparent !important'
                            },
                            "div.MuiYearPicker-root > .PrivatePickersYear-modeDesktop > .Mui-selected": {
                                background: '#408697 !important'
                            },
                            "div.MuiYearPicker-root > .PrivatePickersYear-modeMobile > .Mui-selected": {
                                background: '#408697 !important'
                            },
                            ".MuiPickersDay-root.Mui-selected": {
                                background: '#408697 !important'
                            }

                        }
                    }}

                    renderInput={(params) => <TextField required {...params} InputProps={{
                        sx: {
                            ".MuiButtonBase-root": {
                                padding: '8px !important',

                            },
                        }
                    }} />}
                />
            </LocalizationProvider>
        )}
    />
}
const useStyles = makeStyles({
    input: {
        fontFamily: 'initial !important',
        fontSize: 'initial !important',
        fontWeight: 'initial !important',
        backgroundColor: 'initial !important',
        padding: 'initial !important',
    },
    datePicker: {
        '& button': {
            fontFamily: 'initial !important',
            fontSize: 'initial !important',
            fontWeight: 'initial !important',
            backgroundColor: 'initial !important',
            padding: 'initial !important',
        },
    },
});



export const DateNTimePicker: FunctionComponent<DateFieldProps> = (props) => {
    const classes = useStyles();
    const [value, setValue] = React.useState<Dayjs | null>(
        dayjs(),
    );

    const handleChange = (newValue: Dayjs | null) => {
        setValue(newValue);
    };
    const [date, setDate] = React.useState<Dayjs | null>(null);
    return <Controller
        control={props.control}
        name={props.name}
        render={({ field, fieldState: { error } }) => (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <TextField
                    id="datetime-local"
                    label={props.label}
                    type="datetime-local"
                    onChange={(newValue) => {
                        newValue && props.setValue(props.name, dayjs(newValue.target.value).unix())
                    }}
                    sx={{ width: '100%' }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onKeyDown={(e) => e.preventDefault()}
                />
            </LocalizationProvider>
        )}
    />

}

const ResponsiveTextField = styled(TextField)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: '100%',

    },
    [theme.breakpoints.up('sm')]: {
        flex: 1,

    },
    borderRadius: '4px'
}));
type Options = {
    value: string,
    label: string
}
const styles = {
    formLabel: {
        color: "#000",
        "&.Mui-focused": {
            color: "#000"
        }
    }
};
export const FormRadioField: FunctionComponent<{ control: any, name: string, label: string, options: Array<Options>, disabled?: boolean }> = (props) => {
    return <Controller
        rules={{ required: false }}
        control={props.control}
        name={props.name}
        render={({ field }) => (
            <>
                <StyleFormLabel>{props.label}</StyleFormLabel>
                <RadioGroup
                    {...field}
                    row
                    style={{ justifyContent: 'center' }}
                    onChange={(event, value) => field.onChange(value)}
                    value={field.value}
                >
                    {props.options.map(opt => {
                        return <FormControlLabel id={opt.label} value={opt.value} control={<Radio disabled={!props.disabled}
                        />} label={opt.label} sx={{
                            "&label.Mui-focused": {
                                color: 'transparent !important'
                            },
                        }} />
                    })}

                </RadioGroup>
            </>
        )}
    />
}

export const FormSelectField: FunctionComponent<{ control: any, name: string, label: string, helpText?: string, options: Array<Options>, disabled?: boolean }> = (props) => {
    return <Controller
        rules={{ required: false }}
        control={props.control}
        name={props.name}
        render={({ field, fieldState: { error } }) => (
            <>
                <StyleFormLabel id="demo-radio-buttons-group-label" >{props.label}</StyleFormLabel>
                <ResponsiveTextField
                    {...field}
                    id="outlined-select-colour"
                    select
                    InputProps={{ sx: { height: 30, borderRadius: 0 } }}
                    error={error !== undefined} helperText={error ? validateHelper[props.name][error.type] : ''}
                    disabled={!props.disabled}
                >
                    {props.options.map(opt => {
                        return <MenuItem key={opt.label} value={opt.value}>
                            {opt.value}
                        </MenuItem>
                    })}

                </ResponsiveTextField>
            </>
        )}
    />
}

export const FormAddressField: FunctionComponent<{ control: any, name: string, label: string, helpText?: string }> = (props) => {
    const [region, setRegion] = React.useState("");
    const [city, setCity] = React.useState("");

    return (
        <Controller
            rules={{ required: false }}
            control={props.control}
            name={props.name}
            render={({ field, fieldState: { error } }) => (
                <>
                    <StyleFormLabel id="demo-radio-buttons-group-label" >{props.label}</StyleFormLabel>

                    <CascadeSelection region={region} setRegion={setRegion} city={city} setCity={setCity} onChange={(region, city) => field.onChange({ region, city })} />
                </>
            )}
        />
    );
};


const StyleFormLabel = styled(FormLabel)({
    'font-weight': '800 !important',
    'fontSize': '14px',
    'width': '110px',
    '&.Mui-focused': {
        color: '#00000099 !important'
    }
})
